const scope_0 = require('/Users/joeloliveira/Development/WWW/Projects/videophose/.cache/caches/gatsby-mdx/mdx-scopes-dir/1e5bd7553f37ac8f3bb20e0ae0f2882f.js').default;export default
        Object.assign({}, scope_0 )
    